exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".change-to-local-pickup[data-v-f319052c]{margin:-10px 0 18px}.change-to-local-pickup a[data-v-f319052c]{text-decoration:underline;font-weight:700}.change-to-local-pickup .green[data-v-f319052c]{font-weight:700}", ""]);

// exports
